import React, { Fragment } from "react";
import {
  EuiIcon,
  EuiTabbedContent,
  EuiText,
  EuiSpacer,
  EuiDescriptionList,
  EuiAvatar,
  EuiFlexGroup,
  EuiCommentList,
  EuiComment,
  EuiCode,
  getColorMode,
  formatDate,
  EuiTitle,
  EuiLoadingSpinner,
  EuiBadge,
  EuiButton,
  EuiButtonIcon,
  EuiModal,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiModalBody,
  EuiCodeBlock,
  EuiModalFooter,
} from "@elastic/eui";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import OrganizationService from "../../services/organization-service";
import { useState } from "react";
import { Extensions } from "../Extensions/Extensions";
import { LogsTable } from "../Logs/LogsTable";
import LogsService from "../../services/logs-service";
import axios from "axios";
import { Chart, BarSeries, Axis } from "@elastic/charts";
import "@elastic/charts/dist/theme_light.css";
import ServicesStatus from "../../services/serviceStatus.service";
import UsersTable from "../Users/UsersTable";
import DomainsTable from "../Domains/DomainsTable";
import TrunkTable from "../Trunks/TrunkTable";
import TeamsUsersTable from "../TeamsUsers/TeamsUsersTable";

export const OrganizationDetails = (props) => {
  const [listItems, setListItems] = useState([]);
  const [logs, setLogs] = useState([]);
  const [logsStats, setLogsStats] = useState([]);
  const [authGraph, setAuthGraph] = useState("");
  const [authGraphDecoded, setAuthGraphDecoded] = useState();
  const [teamsToken, setTeamsToken] = useState("");
  const [teamsTokenDecoded, setTeamsTokenDecoded] = useState();
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [dataModalDecoded, setDataModalDecoded] = useState();
  const [organizationInfo, setOrganizationInfo] = useState(null);
  const [isLoadingOrganizationInfo, setIsLoadingOrganizationInfo] = useState(true);

  const isDatabaseCompany =
  organizationInfo?.permissions === "database" ||
  props?.data?.permissions === "database" ||
  props?.permissions === "database";

  console.log("OrganizationDetails props:", props);
  console.log("isDatabaseCompany:", isDatabaseCompany);

  const getColor = (result) => {
    if (result === "Danger") {
      return "danger";
    }

    if (result === "Warning") {
      return "warning";
    }

    return "success";
  };

  const usersTab = {
    id: "users",
    name: (
      <>
        <EuiIcon
          type={
            "https://commons.wikimedia.org/wiki/Special:FilePath/Microsoft_Office_Teams_(2018–present).svg"
          }
          title="Custom SVG icon"
        />
        &nbsp; Users
      </>
    ),
    content: (
      <Fragment>
        <EuiSpacer />
        <TeamsUsersTable
          data={{
            ...props,
            permissions: organizationInfo?.permissions || props?.permissions,
            companyCode: organizationInfo?.companyCode || props?.companyCode,
          }}
        />
      </Fragment>
    ),
  };

  const tabs = isDatabaseCompany
    ? [usersTab]
    : [
        {
          id: "o365Users",
          name: (
            <>
              <EuiIcon
                type={
                  "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                }
                title="Custom SVG icon"
              />
              &nbsp; O365 - Users
            </>
          ),
          content: (
            <Fragment>
              <EuiSpacer />
              <UsersTable data={props} />
            </Fragment>
          ),
        },
        {
          id: "o365Domains",
          name: (
            <>
              <EuiIcon
                type={
                  "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                }
                title="Custom SVG icon"
              />
              &nbsp; O365 - Domains
            </>
          ),
          content: (
            <Fragment>
              <EuiSpacer />
              <DomainsTable data={props} />
            </Fragment>
          ),
        },
        usersTab,

        // {
        //   id: "info",
        //   name: "General Information",
        //   content: (
        //     <Fragment>
        //       <EuiSpacer />
        //       <EuiFlexGroup>
        //         <div
        //           style={{
        //             width: "23%",
        //           }}
        //         >
        //           <EuiDescriptionList textStyle="reverse" listItems={listItems} />
        //         </div>
        //       </EuiFlexGroup>
        //     </Fragment>
        //   ),
        // },

        // {
        //   id: "users",
        //   name: (
        //     <>
        //       <EuiIcon type="users" />
        //       &nbsp; Extensions
        //     </>
        //   ),
        //   content: (
        //     <Fragment>
        //       <EuiSpacer />
        //       <Extensions data={props} />
        //     </Fragment>
        //   ),
        // },

        {
          id: "o365Trunks",
          name: (
            <>
              <EuiIcon
                type={
                  "https://commons.wikimedia.org/wiki/Special:FilePath/Microsoft_Office_Teams_(2018–present).svg"
                }
                title="Custom SVG icon"
              />
              &nbsp; Trunks
            </>
          ),
          content: (
            <Fragment>
              <EuiSpacer />
              <TrunkTable data={props} />
            </Fragment>
          ),
        },
        {
          id: "interactions",
          disabled: true,
          name: (
            <>
              <EuiIcon type="list" />
              &nbsp; Logs
            </>
          ),
          content: (
            <Fragment>
              <EuiSpacer />
              <LogsTable data={props} />
            </Fragment>
          ),
        },
      ];

  useEffect(() => {
    const token = sessionStorage.getItem("krakenT");
    const id = props.company;
    const pToken = sessionStorage.getItem("pToken");

    OrganizationService.getOrganizationInfo(token, id)
      .then((response) => {
        const companyData = response.data.message.data;

        setOrganizationInfo(companyData);
        setIsLoadingOrganizationInfo(false);

        setListItems([
          {
            title: "Name",
            description:
              (
                <>
                  <EuiAvatar
                    size="s"
                    name="Cat"
                    imageUrl={companyData.companyLogo}
                  />
                  &nbsp; {companyData.nameLong}
                </>
              ) || "",
          },
          {
            title: "CIF",
            description: companyData.cif || "",
          },
          {
            title: "Contact Name",
            description: companyData.contact || "",
          },
          {
            title: "Contact Phone",
            description: companyData.phone || "",
          },
          {
            title: "Contact Mail",
            description: companyData.mail || "",
          },
          {
            title: "Company Code",
            description: companyData.companyCode || "",
          },
          {
            title: "Node",
            description: companyData.node_url || "",
          },
          {
            title: "Created At",
            description: formatDate(companyData.createdAt) || "",
          },
          {
            title: "Updated At",
            description: formatDate(companyData.updatedAt) || "",
          },
        ]);

        // ServicesStatus.teamsTokens(token, id, companyData.mail)
        //   .then((response) => {
        //     setAuthGraph(response.data.authGraph.token);
        //     setAuthGraphDecoded(jwt_decode(response.data.authGraph.token));
        //     setTeamsToken(response.data.authTeams.token);
        //     setTeamsTokenDecoded(jwt_decode(response.data.authTeams.token));
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingOrganizationInfo(false);
      });

    // LogsService.logs(token, id)
    //   .then(async (response) => {
    //     const logsList = [];
    //     for (let log of response.data) {
    //       try {
    //         const photo = await axios.get(
    //           `https://graph.microsoft.com/v1.0/users/${log.username}/photo/$value`,
    //           {
    //             headers: {
    //               Authorization: `Bearer ${pToken}`,
    //             },
    //             responseType: "blob",
    //           }
    //         );
    //         const url = window.URL || window.webkitURL;
    //         const blobUrl = url.createObjectURL(photo.data);
    //         logsList.push({
    //           username: log.username,
    //           description: log.description,
    //           result: log.result,
    //           resultDescription: log.resultDescription,
    //           ip: log.ip,
    //           userAgent: log.userAgent,
    //           createdAt: formatDate(log.createdAt),
    //           photo: blobUrl,
    //         });
    //       } catch (error) {
    //         console.log("ERROR CATCHED", error);
    //       }
    //     }
    //     console.log(logsList);
    //     setLogs(logsList);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    // LogsService.logsStatsByMonth(token, id)
    //   .then((response) => {
    //     setLogsStats(response.data);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }, [props]);

  if (isLoadingOrganizationInfo) {
    return (
      <div style={{ padding: "24px" }}>
        <EuiLoadingSpinner size="xl" />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
      }}
    >
      <EuiTabbedContent
        key={isDatabaseCompany ? "database-tabs" : "normal-tabs"}
        tabs={tabs}
        initialSelectedTab={tabs[0]}
        onTabClick={(tab) => {
          console.log("clicked tab", tab);
        }}
      />

      {showModal && (
        <EuiModal onClose={() => setShowModal(false)}>
          <EuiModalHeader>
            <EuiModalHeaderTitle>
              <h1>TOKEN Data</h1>
            </EuiModalHeaderTitle>
          </EuiModalHeader>

          <EuiModalBody>
            Token:
            <EuiSpacer size="xs" />
            <EuiCodeBlock fontSize="m" paddingSize="m">
              {dataModal}
            </EuiCodeBlock>
            <EuiSpacer size="xs" />
            Decoded:
            <EuiSpacer size="xs" />
            <EuiCodeBlock language="json" fontSize="m" paddingSize="m">
              {`${JSON.stringify(dataModalDecoded, null, "\t")}`}
            </EuiCodeBlock>
          </EuiModalBody>

          <EuiModalFooter>
            <EuiButton onClick={() => setShowModal(false)} fill>
              Close
            </EuiButton>
          </EuiModalFooter>
        </EuiModal>
      )}
    </div>
  );
};